/*global VeloxViewController, moment, veloxScriptLoader, VeloxWebView*/

var upload = require("../../util/upload") ;

var backupController = new VeloxViewController({
    directory: "views/backup",
    name: "backup",
    route: "backup",
    openInPopup: true,
    
});

var DB_NAME = "db.json" ;
var BIN_NAME = "bin.zip" ;

function createBackupZip(dbString, binzip, callback){
    var zip = new window.JSZip();
    zip.file(DB_NAME, dbString);
    if(binzip){
        zip.file(BIN_NAME, binzip);
    }
    zip.generateAsync({type:"blob"}).then(function(content) {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(content);
        link.download = "backup_"+moment().format("YYYYMMDDHHmmss")+".bbak";
        document.body.appendChild(link) ;
        link.click();
        callback(null) ;
        setTimeout(function(){
            document.body.removeChild(link) ;
        }, 10) ;
    }).catch(function(err){
        callback(err) ;
    });
}

var JSZIP_VERSION = "3.1.5" ;
var JZIP_LIB =[
    {
        name: "jszip",
        type: "js",
        version: JSZIP_VERSION,
        cdn: "https://cdnjs.cloudflare.com/ajax/libs/jszip/$VERSION/jszip.min.js",
        bowerPath: "jszip/dist/jszip.min.js",
        npmPath: "jszip/dist/jszip.min.js",
    }
] ;

backupController.onBackup = function(){
    this.view.longTask(function(done){
        veloxScriptLoader.load(JZIP_LIB, function (err) {
            if(err){ return done(err) ;}
            this.api.api.backup(function(err, dbString){
                if(err){ return done(err) ;}
                if(window.native){
                    this.api.backupBinary(function(err, binzip){
                        if(err){ return done(err) ;}
                        createBackupZip(dbString, binzip, function(err){
                            if(err){ return done(err) ;}
                            done() ;
                        }) ;
                    }.bind(this)) ;
                }else{
                    createBackupZip(dbString, null, function(err){
                        if(err){ return done(err) ;}
                        done() ;
                    }) ;
                }
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;



backupController.onRestore = function(){
    upload({
        multiple: false, 
        accept: ".bbak",
        sizeLimit: 1000000000000
    },function(file){
        if(!file){ return ;}
        backupController.view.question(VeloxWebView.tr("backup.warnErase"),
        {size: "medium"},
        [
            {label: VeloxWebView.tr("backup.yesApply"), code: "yes", className: "btn-outline-danger"},
            {label: VeloxWebView.tr("backup.noDontApply"), code: "no", className: "btn-outline-secondary", focus: true, isDefault: true}
        ], function(answer){
            if(answer === "yes"){
                this.view.longTask(function(done){
                    veloxScriptLoader.load(JZIP_LIB, function (err) {
                        if(err){ return done(err) ;}
                        var reader = new FileReader();
        
                        reader.onload = function (e) {
                            var buffer = e.target.result ;
                            window.JSZip.loadAsync(buffer).then(function (zip) {
                                zip.file(DB_NAME).async("string").then(function(dbString){
                                    this.api.api.restore(dbString,function(err){
                                        if(err){ return done(err) ;}
                                        zip.file(BIN_NAME).async("arraybuffer").then(function(binBuffer){
                                            this.api.restoreBinary(binBuffer, function(err){
                                                if(err){ return done(err) ;}
                                                done() ;
                                                VeloxWebView.info(VeloxWebView.tr("backup.success")) ;
                                                this.navigate("/") ;
                                            }.bind(this));
                                        }.bind(this)).catch(function(err){
                                            done(err) ;
                                        }) ;
                                    }.bind(this));
                                }.bind(this)).catch(function(err){
                                    done(err) ;
                                }); 
                            }.bind(this)).catch(function(err){
                                done(err) ;
                            });
                        }.bind(this);
                        reader.readAsArrayBuffer(file);
                    }.bind(this)) ;
                }.bind(this)) ;
            }
        }.bind(this)) ;
    }.bind(this));
} ;

module.exports = backupController ;